import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import {
  memo,
  useContext,
  useLayoutEffect,
  useState,
  type ReactNode,
} from "react";
import { VoiceContextV2, type VoiceV2State } from "./voice-context-v2";
import { VoiceContextV2Provider } from "./voice-context-v2-provider";

const SessionBridge = memo(function SessionBridge({
  onSession,
}: {
  readonly onSession: (session: VoiceV2State | undefined) => void;
}) {
  const session = useContext(VoiceContextV2);
  useLayoutEffect(() => {
    onSession(session);
  }, [onSession, session]);
  useLayoutEffect(() => () => onSession(undefined), [onSession]);
  return null;
});

/** Holds the voice session above the router so section switches don't end calls. */
export const VoiceSessionHost = memo(function VoiceSessionHost({
  children,
}: {
  readonly children: ReactNode;
}) {
  const user = useContext(UserContext);
  const effectApi = useContext(EffectApiClientContext);
  const [session, setSession] = useState<VoiceV2State | undefined>(undefined);

  return (
    <VoiceContextV2.Provider value={session}>
      {children}
      {user != null && effectApi != null && (
        <VoiceContextV2Provider key={user._id}>
          <SessionBridge onSession={setSession} />
        </VoiceContextV2Provider>
      )}
    </VoiceContextV2.Provider>
  );
});
